// import { SHOW_ORDER_DETAILS, TOGGLE_MODAL } from 'actionTypes/orderDetailsActionTypes';

// // action creators
// export const setOrderDetails = (payload) => ({
//   type: SHOW_ORDER_DETAILS,
//   payload,
// });

// export const toggleModal = (payload) => ({
//   type: TOGGLE_MODAL,
//   payload
// })

// export default {
//   setOrderDetails,
//   toggleModal
// };

import {
  SHOW_ORDER_DETAILS,
  TOGGLE_MODAL,
  TOGGLE_ADD_ORDER_MODAL,
} from 'actionTypes/orderDetailsActionTypes';

// action creators
export const setOrderDetails = (payload) => ({
  type: SHOW_ORDER_DETAILS,
  payload,
});

export const toggleModal = (payload) => ({
  type: TOGGLE_MODAL,
  payload,
});

export const toggleAddOrderModal = (payload) => ({
  type: TOGGLE_ADD_ORDER_MODAL,
  payload,
});

export default {
  setOrderDetails,
  toggleModal,
  toggleAddOrderModal,
};
